import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M21 7.15a1.7 1.7 0 00-1.85.3l-2.15 2V8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h9a3 3 0 003-3v-1.45l2.16 2a1.74 1.74 0 001.16.45c.238 0 .473-.052.69-.15a1.6 1.6 0 001-1.48V8.63A1.6 1.6 0 0021 7.15zM15 16a1 1 0 01-1 1H5a1 1 0 01-1-1V8a1 1 0 011-1h9a1 1 0 011 1v8zm5-1.4L17.19 12 20 9.4v5.2z",
			fillRule: "nonzero"
		})
	})
});
export { SvgVideoOn as ReactComponent };
